// web/src/i18n/rtl-langs.ts
//
// Single source of truth for which language codes render right-to-left.
// Used by LanguageProvider (sets <html dir>), DirectionProvider mount in
// AppShell, and `useLanguage().rtl` for component-level conditional styling.
//
// Adding a new RTL language: append the code here. No code change elsewhere.
export const RTL_LANGUAGE_CODES: ReadonlySet<string> = new Set([
  "ar",
  "he",
  "fa",
  "ur",
]);

export function isRTL(languageCode: string): boolean {
  return RTL_LANGUAGE_CODES.has(languageCode);
}
